<template>
  <ElementRTE class="rte" :rte="rte" />
</template>

<script>
import ElementRTE from '@/elements/RTE.vue';
export default {
  name: 'ComponentContentRTE',
  components: {
    ElementRTE,
  },
  computed: {},
  props: {
    rte: Object,
  },
  data() {
    return {};
  },
  mounted() {},
  updated() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/content/_rte.scss';
</style>
